import AppLoader from '@/components/AppLoader';
import { Box, ChakraProvider, Container } from '@chakra-ui/react';
import DaySlots from './components/DaySlots/DaySlots';
import Header from './components/Header/Header';
import Month from './components/Month/Month';
import useBookingPage from './useBookingPage2';

export default function BP2() {
	const {
		availabilityQuery,
		daySlots,
		from,
		query,
		selectedDay,
		theme,
		timeZone,
		isLoading,
		handleSlotClick,
		handleNextClick,
		handlePrevClick,
		handleTimeZoneChange,
		handleDayClick,
	} = useBookingPage();

	if (!query.data) {
		return <AppLoader />;
	}

	return (
		<ChakraProvider theme={theme}>
			<Box w="100dvw" h="100dvh" overflow="auto" display="grid">
				<Container
					opacity={isLoading ? 0.7 : 1}
					p={0}
					m="auto"
					bg="white"
					w="100%"
					h="100%"
					maxH={{ base: '100%', lg: 'container.md' }}
					maxW={{ base: '100%', lg: 'container.lg' }}
					minW={{ base: '100%', md: 'container.sm', lg: 'container.md', xl: 'container.lg' }}
					display="grid"
					gridTemplateRows={{ base: 'auto 1fr auto', lg: 'auto 1fr' }}
					gridTemplateColumns={{ base: 'auto', lg: '3fr 1fr' }}
					borderWidth={1}
					borderColor="gray.200"
					borderRadius={{ base: 0, lg: 'md' }}
					mx={{ base: '', md: 'auto' }}
					my={{ lg: 'auto' }}
					overflow={{ base: 'auto', lg: 'auto' }}
				>
					<Header name={query.data.name} description={query.data.description} imageSrc={query.data.imageUrl} />

					{availabilityQuery.data ? (
						<>
							<Month
								locale={navigator.language}
								timeZone={timeZone}
								onNextClick={handleNextClick}
								onPrevClick={handlePrevClick}
								onTimeZoneChange={handleTimeZoneChange}
								onDayClick={handleDayClick}
								month={from.month}
								year={from.year}
								selectedDay={selectedDay}
								slots={availabilityQuery.data.timeSlots}
							/>
							<DaySlots timeZone={timeZone} onSlotClick={handleSlotClick} selectedDay={selectedDay} slots={daySlots} />
						</>
					) : null}
				</Container>
			</Box>
		</ChakraProvider>
	);
}
